import {
  translationsNamespace as footerTranslationsNamespace,
  defaultTranslations as footerDefaultTranslations,
} from './defaultTranslations_footer';
import {
  translationsNamespace as languageSwitcherTranslationsNamespace,
  defaultTranslations as languageSwitcherDefaultTranslations,
} from './defaultTranslations_language-switcher';

/**
 * Pack with footer and language-switcher
 */
export const defaultTranslationsWithNamespaces = {
  [footerTranslationsNamespace]: footerDefaultTranslations,
  [languageSwitcherTranslationsNamespace]: languageSwitcherDefaultTranslations,
};
